import { useIsFeatureEnabled } from '@innovyze/stylovyze';
import { createAssetSchemaHooks } from '@innovyze/lib_asset_schema_react';
import { fetchImportedAssetTypes } from '@innovyze/lib-am-common/Apis';

// Pickers only offer what the i360-schema-catalog flag releases and the
// tenant has imported.
export const {
	useAssetPickerOptions: useReleasedAssetPickerOptions,
	useImportedAssetTypes,
} = createAssetSchemaHooks(
	() => useIsFeatureEnabled('i360-schema-catalog'),
	undefined,
	{ fetchImportedAssetTypes },
);

// Display names and schema reads must resolve for any asset type a saved
// asset group set or rule may reference, so an open flag value leaves nothing
// gated out.
const OPEN_FLAG = { assets: {} };

export const { useAssetSchema, useAssetTypeSummary, useSystemType } =
	createAssetSchemaHooks(() => OPEN_FLAG);
